const Api = {
    '/api/waiting-live/set-anchor-schedule' : 1, // 更新达人档期
    '/api/waiting-live/confirm-url': 1, // 校验链接
    '/api/waiting-live/edit-product-id': 1, // 快手变更id
    '/api/waiting-live/edit-url': 1, // 变更商品链接
    '/api/sample-order/deliver': 1, // 拒绝发货
    
}

export default{
    Api
}